/**
 * A class defining simple cookie handling functions.
 * @class
 */
export default class CookieJar {

	/**
	 * Static method which creates or updates a cookie.
	 * @static
	 * @param {String} cookieName Name of the cookie.
	 * @param {*} cookieValue Valuje of the cookie.
	 * @param {Number} expirationHours Number of hours until coupon expires.
	 * @returns {void}
	 */
	static setCookie (cookieName, cookieValue, expirationHours) {
		const date = new Date();
		// eslint-disable-next-line no-extra-parens
		date.setTime(date.getTime() + (expirationHours * 60 * 60 * 1000));
		const expires = 'expires=' + date.toUTCString();
		document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';
	}

	/**
	 * Static method which takes a cookie name and returns the value of the cookie if found, else returns empty string.
	 * @static
	 * @param {String} cookieName Name of the cooke you're attempting to read.
	 * @returns {String}
	 */
	static getCookie (cookieName) {
		const name = cookieName + '=';
		const decodedCookies = decodeURIComponent(document.cookie);
		const cookiesArray = decodedCookies.split(';');
		for (let i = 0, len = cookiesArray.length; i < len; i++) {
			let cookieString = cookiesArray[i];
			while (cookieString.charAt(0) === ' ') {
				cookieString = cookieString.substring(1);
			}
			if (cookieString.indexOf(name) === 0) {
				return cookieString.substring(name.length, cookieString.length);
			}
		}
		return '';
	}

	/**
	 * Static method which deletes a cookie by clearing its value and setting its expiration hours to -1.
	 * @static
	 * @param {String} cookieName
	 * @returns {void}
	 */
	static forgetCookie (cookieName) {
		this.setCookie(cookieName, '', -1);
	};

}
